import {
  SET_USER,
  SET_ACCESS_TOKEN,
  SET_COLOR,
  SHOW_INVALID_CREDENTIALS_MODAL,
} from "src/vuex/mutationTypes";

import * as Cookies from "js-cookie";
import router from "src/http/router";
import _ from "lodash";
import UserRole from "src/util/valueObjects/userRole";
import userPermission from "@/util/valueObjects/userPermission";
import tree from "element-ui/packages/table/src/store/tree";

const defaultState = {
  user: null,
  accessToken: null,
  color: null,
  ShowInvalidCredentialsModal: false,
};

const actions = {
  async showInvalidCredentialsModalAction(context) {
    context.commit(SHOW_INVALID_CREDENTIALS_MODAL, true)
  },

  async hideInvalidCredentialsModalAction(context){
    context.commit(SHOW_INVALID_CREDENTIALS_MODAL, false)
  },

  async login(context, token) {
    await this.dispatch("setSettingsInLocalStorage", token);
    await this.dispatch("setTokenCookie", token);
    await this.dispatch("setUserFromCookie");
    await this.dispatch("fetchSettings");
  },

  clearLoggedUser(context) {
    Cookies.remove("token", {path: "/"});
    context.commit(SET_USER, null);
    context.commit(SET_ACCESS_TOKEN, null);
  },

  setSettingsInLocalStorage(context, token) {
    if (token.user.company.custom_settings);
      localStorage.setItem('customSettings', JSON.stringify(token.user.company.custom_settings));
  },

  setTokenCookie(context, token) {
    if (token.user.company.custom_settings)
      delete token.user.company.custom_settings;

    Cookies.set("token", JSON.stringify(token), {path: "/"});
  },

  setColorCookie(context, color) {
    localStorage.setItem('dark_mode', color);
    context.commit(SET_COLOR, color);
  },

  setUserFromCookie(context) {
    let token = Cookies.getJSON("token");

    if (token) {
      context.commit(SET_ACCESS_TOKEN, token.access_token);
      context.commit(SET_USER, token.user);
    }
  },

  redirectToDashboard(context, token) {
    router.push({name: `${token.user.role.name}.dashboard`});
  },

  redirectToMainMenu(context) {
    router.push({name: 'home.menu'});
  },

  redirectToOrder(context, token) {
    router.push({name: `${token.user.role.name}.order`});
  },

  redirectToModule(context, data) {
    let IntegraPermission = userPermission.ALL_MODULES.INTEGRA_MANAGER.value;

    const user_role = data.token.user.role.id;
    const user_permissions = data.token.user.permissions;

    if (data.module === IntegraPermission) {
      let isShipperFinancier = false;
      let isShipperFinancierBasic = false;
      if (user_role === UserRole.SHIPPER.index) {
        if (user_permissions.includes(userPermission.INTEGRA_MANAGER__FINANCIER.value)) {
          isShipperFinancier = true;
        } else if (user_permissions.includes(userPermission.INTEGRA_MANAGER__FINANCIER_BASIC.value)) {
          isShipperFinancierBasic = true;
        }
      }

      if (user_role === UserRole.TRANSPORTER.index) {
        router.push({name: `${data.token.user.role.name}.order_proposals`})
      } else if (user_role === UserRole.SUPPLIER.index || isShipperFinancier) {
        router.push({name: `${data.token.user.role.name}.order`});
      } else if (isShipperFinancierBasic) {
        router.push({name: `${data.token.user.role.name}.canhoto`});
      } else {
        router.push({name: `${data.token.user.role.name}.dashboard`}).catch(failure => {
          console.log(failure)
        });
      }
    } else if (data.module === userPermission.ALL_MODULES.BILLING.value) {
      router.push({name: data.module});
    } else if (data.module === userPermission.ALL_MODULES.FINANCE.value) {
      if (user_role === UserRole.TRANSPORTER.index || user_role === UserRole.SHIPPER.index || user_role === UserRole.TAKER.index){
        router.push({name: `${data.module}`});
      }
      else{
        router.push({name: `${data.token.user.role.name}.${data.module}`});
      }
    } else if (data.module === userPermission.ALL_MODULES.QUOTATION.value) {
      router.push({name: `${data.token.user.role.name}.${data.module}.order_quotes`});
    } else {
      router.push({name: `${data.token.user.role.name}.${data.module}`});
    }
  },

  async logout(context, redirect = "/") {
    this.dispatch("clearLoggedUser");

    // Set pageTitle to default
    context.commit('pageTitle', 0);

    // await this.dispatch("fetchSettings");
    router.push({name: "login", query: {redirect: redirect.path}});
  },

  async setAvatarPath(context, avatar_path) {
    let token = Cookies.getJSON("token");
    token.user.company.avatar_path = avatar_path;
    this.dispatch("setTokenCookie", token);
  },

  async createTmsUser(context) {
    await router.push({name: "create_tms_user"});
  },

};

const mutations = {
  [SHOW_INVALID_CREDENTIALS_MODAL]: (state, value) => {
    state.ShowInvalidCredentialsModal = value;
  },
  [SET_USER]: (state, user) => {
    state.user = user;
  },
  [SET_ACCESS_TOKEN]: (state, accessToken) => {
    state.accessToken = accessToken;
  },
  [SET_COLOR]: (state, color) => {
    state.color = color;
  }
};

const getters = {
  getToken: () => Cookies.getJSON("token"),
  getAccessToken: state => state.accessToken,
  getLoggedUser: state => state.user,
  getColor: () => localStorage.getItem("dark_mode"),
  getShowInvalidCredentialsModal: state => state.ShowInvalidCredentialsModal,
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations
};
